"use client";

import NextLink from "next/link";
import type { AnchorHTMLAttributes } from "react";
import { Button, ButtonProps } from "@mui/material";

type AppLinkButtonProps = Omit<ButtonProps, "href" | "component"> &
  Pick<AnchorHTMLAttributes<HTMLAnchorElement>, "target" | "rel"> & {
    href: string;
  };

export const AppLinkButton = ({ href, ...props }: AppLinkButtonProps) => {
  return <Button LinkComponent={NextLink} href={href} {...props} />;
};
